import StatusCard from './components/Card';
import Content from './components/Content';
import StatusLayout from './components/StatusLayout';
import StatusProvider from './context';

const Status: React.FunctionComponent = function () {
  return (
    <StatusProvider>
      <StatusLayout>
        <StatusCard>
          <div className="py-2 md:pt-6">
            <Content />
          </div>
        </StatusCard>
      </StatusLayout>
    </StatusProvider>
  );
};

export default Status;
